import { render, staticRenderFns } from "./PixAcompanhamento.vue?vue&type=template&id=3190f298"
import script from "./PixAcompanhamento.vue?vue&type=script&lang=js"
export * from "./PixAcompanhamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports